import React, { useEffect, useState } from "react"
import { useAuth } from "../../context/AuthContext"
import { supabase } from "../../lib/supabaseClient"
import { useNavigate, useLocation } from "react-router-dom"

const PersonalInfoPage: React.FC = () => {
  const { profile, refreshProfile } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const redirectAfterSave = params.get('redirect') || '/account'

  const [fullName, setFullName] = useState("")
  const [phone, setPhone] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!profile) return
    setFullName(profile.full_name || "")
    setPhone(profile.phone || "")
  }, [profile])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    const { error } = await supabase
      .from("profiles")
      .update({
        full_name: fullName,
        phone: phone || null,
      })
      .eq("id", profile?.id)

    setLoading(false)

    if (error) {
      alert("Erreur lors de la mise à jour.")
      return
    }

    await refreshProfile()
    navigate(redirectAfterSave, { replace: true })
  }

  return (
    <div className="card" style={{ maxWidth: 600, margin: "2rem auto" }}>
      <h1 className="card-title">Informations personnelles</h1>

      {params.get('redirect') && (
        <p data-testid="personal-info-banner" style={{ color: '#f59e0b', marginBottom: '1rem', fontSize: '0.9rem' }}>
          Merci de compléter tes informations avant de continuer.
        </p>
      )}

      <form onSubmit={handleSave}>
        <label className="label">Nom complet</label>
        <input
          data-testid="personal-info-fullname"
          className="input"
          value={fullName}
          onChange={e => setFullName(e.target.value)}
        />

        <label className="label" style={{ marginTop: "1rem" }}>Téléphone</label>
        <input
          data-testid="personal-info-phone"
          className="input"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          placeholder="+41 XX XXX XX XX"
        />

        <button
          data-testid="personal-info-save"
          className="btn btn-primary"
          type="submit"
          style={{ marginTop: "1.5rem" }}
        >
          {loading ? "Enregistrement…" : "Enregistrer"}
        </button>
      </form>
    </div>
  )
}

export default PersonalInfoPage
